import React, { useContext, useEffect, useState } from 'react';
import styles from './PermissionsOverview.module.css';
import PermissionsPath from './PermissionsPath';
import AuthenticationContext from 'config/context/authenticationContext';
import PermissionCard from './PermissionCard';
import Loader from 'components/shared/loader/Loader';

const PermissionsOverview = () => {
    const [path, setPath] = useState(["owner"]);
    const { permissionsData } = useContext(AuthenticationContext);
    const { permissionsLoading } = useContext(AuthenticationContext);

    const getCurrentPermission = (permissions, path) => {
        let current = permissions;
        for (let i = 1; i < path.length; i++) {
            current = current?.children?.find(child => child.name === path[i]);
            if (!current) break;
        }
        return current;
    };

    const currentPermission = getCurrentPermission(permissionsData.permissions, path);

    if (permissionsLoading) {
        return (
            <div className={styles.loader_container}>
                <Loader />
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <PermissionsPath path={path} setPath={setPath} />
            <div className={styles.cards_container}>
                {currentPermission?.children?.map((c) => {
                    const compositions = permissionsData.permissions.required_authorities
                        ?.filter(auth => auth.minimum_required_authority.permission === c.name)
                        .map(auth => auth.composition);
                    return (
                        <PermissionCard
                            key={c?.name}
                            data={c}
                            compositions={compositions}
                            path={path}
                            setPath={setPath}
                        />
                    );
                }
                )}
            </div>
        </div>
    )
}

export default PermissionsOverview;